import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const ReEnrollRedux = createActions(
  {
    reEnrollRequest: ['studentId', 'data'],
    reEnrollSuccess: ['data'],
    reEnrollFailure: ['errors'],
  },
  {
    prefix: 'REENROLL_',
    defaultActions: {
    },
  },
)

const { Types, Creators } = ReEnrollRedux
export const ReEnrollTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
})

/* ------------- Reducers ------------- */

const reEnrollRequest = state => state.merge({
  new_reenroll: {
    error: '',
    success: false,
  },
}, d)

const reEnrollSuccess = (state, { data }) => state.merge({
  new_reenroll: {
    error: '',
    success: true,
  },
  ...data,
}, d)

const reEnrollFailure = (state, { errors }) => state.merge({
  new_reenroll: {
    success: false,
    error: errors[0],
  },
}, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.reEnrollRequest]: reEnrollRequest,
    [Types.reEnrollSuccess]: reEnrollSuccess,
    [Types.reEnrollFailure]: reEnrollFailure,
  },
  {
    defaultActions: {
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ReEnrollRedux.js